import { Homologacao } from "./homologacao";
import { PontuacaoHomologacaoEvento } from "./pontuacao-homologacao-evento.model";
import { Natureza } from "./natureza.model";
import { PontuacaoHomologacaoAtividade } from "./pontuacao-atividade.model";

export class HomologacaoAtividade extends Homologacao {

    public id_atividade_natureza?: number;

    public natureza: Natureza;
    public pontuacao_homologacao_atividade: PontuacaoHomologacaoAtividade[];
    public possui_autonomia: boolean;
}


// WEBPACK FOOTER //
// ./src/app/entity/homologacao-atividade.model.ts